<div id="jobs-field-mapping" class="step-page">
    <div class="step-title">
        <div class="row-wrap">
            <div class="row-left">
                <div> Field Mapping</div>
            </div>
            <div class="row-right">
                <div *ngIf="hasAllFieldsToggle" class="common-field-toggle">
                    <label>Common Fields</label>
                    <mat-slide-toggle
                        [(ngModel)]="isAllFields"
                        (change)="onToggleCommonField()">
                    </mat-slide-toggle>
                    <label>All Fields</label>
                </div>
                <div class="btn-groups">
                    <button class="button-general" (click)="goPrev()">Back</button>
                    <button class="button-general" (click)="goNext(true)" [disabled]="!layers || !layers.length">Upload & QC</button>
                </div>
            </div>

        </div>
    </div>
    <div class="step-content">
        <div class="row-wrap tables-wrap">
            <div class="content-left">
                <div class="content-left-upper" [ngStyle]="{'height': hasAllFieldsToggle ? 'calc(100% - 220px)' : '100%'}">
                    <div class="file-table">
                        <div id="file-table">
                            <div class="table-header">
                                <div>&#8203;</div>
                                <!-- <div hidden>&#8203;</div> -->
                                <div>Data File</div>
                                <div> Dataset Category</div>
                                <div>Record Count</div>
                            </div>
                            <div class="table-body">
                                <div class="table-row"
                                    *ngFor="let layer of layers; let idx = index;"
                                    [ngClass]="{'selected-name': layer===selectedLayer}"
                                    style="cursor:pointer;"
                                    (click)="clickLayer(idx)">
                                    <div class="table-cell" title="Delete" >
                                        <div>
                                            <i class="glyphicons glyphicons-remove" (click)="removeLayer(idx)" title="Delete"></i>
                                        </div>
                                    </div>
                                    <!-- <div class="table-cell" hidden>
                                        <div class="glyphicons glyphicons-search" (click)="openPreview(idx)" title="Preview"></div>
                                    </div> -->
                                    <div class="table-cell">
                                        <div>{{layer.name}}</div>
                                    </div>
                                    <div class="table-cell">
                                        <div>{{layer.category}}</div>
                                    </div>
                                    <div class="table-cell">
                                        <div>{{layer.content.numOfRecords}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="preview-content-table" id="preview-content-table">
                        <div style="height:calc(100% - 20px);width:100%;position: absolute;">
                            <div class="watermark"></div>
                            <app-common-datagrid
                                #previewTable
                                class="material"
                                [columnMode]="'force'"					
                                [rows]="previewRows"
                                [columns]="previewColumns"
                                [selectionType]="undefined"
                                [hidePaging]="true"
                            ></app-common-datagrid>
                        </div>
                    </div>
                </div>
                <div class="content-left-lower" *ngIf="hasAllFieldsToggle">
                    <div class="sample-addresses">
                        <!-- <div class="watermark-example"></div> -->
                        <div class="addresses-container">
                            <div *ngFor="let addr of sampleAddresses" class="sample-address">
                                <div *ngFor="let part of addr.parts" [ngClass]="{'selected-addr-part': part.partName.toLowerCase()===selectedAddrPart}">
                                   {{part.value}}{{part.connectedBy === 'hyphen' ? '-' : ''}}<span *ngIf="part.connectedBy === 'space'">&nbsp;</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-right">
                <div id="mapping-table">
                    <div class="table-header">
                        <div>Standard Schema</div>
                        <div>{{agencyName}}</div>
                    </div>
                    <div *ngIf="selectedLayer" class="table-body">
                        <ng-container *ngFor="let col of currStandardCols; let idx = index;">
                            <div *ngIf="!hasAllFieldsToggle||isAllFields||col.isCommonField" class="table-row" (mouseover)="onHoverStandardCol(col)" (mouseout)="onMouseoutStandardCol()">
                                <div class="table-cell">
                                    <div class="icon-circle" [title]="(col.require === 'M' ? 'Mandatory Field': (col.require === 'c' ? 'conditional':'Optional Field'))">{{col.require}}</div>
                                    <div class="icon-circle" title="{{'Defined by ' + col.definedBy}}">{{col.definedBy.substring(0, 1)}}</div>

                                    <div appHtmlTooltip [tooltip]="col.htmlTooltip">{{col.colName}}</div>
                                </div>
                                <div class="table-cell" title="Field Type">
                                    <div>{{col.colType}}</div>
                                </div>
                                <div class="table-cell" title="Field Size">
                                    <div>{{col.colLength}}</div>
                                </div>
                                <div class="table-cell">
                                    <select name="standard-col-{{idx}}"
                                        [ngClass]="{'not-match-prev-col': col.prevMappingCol&& (!col.matchedCol || col.prevMappingCol.toLowerCase()!==col.matchedCol.name.toLowerCase()) }"
                                        title="{{col.prevMappingCol&& (!col.matchedCol || col.matchedCol&&col.prevMappingCol!==col.matchedCol.name) ? 'Previous column mapping dropped:  ' + col.prevMappingCol : ''}}"
                                        [(ngModel)]="col.matchedCol"
                                        (change)="onSelectColumn(idx, true)"
                                        [required]="col.require === 'M'">
                                        <option [value]="''" ></option>
                                        <option *ngFor="let field of fields; let idx = index;"
                                            [ngValue]="field"
                                            [ngClass]="{'mapped-fields-name': mappedFieldNames.indexOf(field.name)!==-1}"
                                            [hidden]="hideField(field, col)">{{field.name}}</option>
                                            <!-- any type of column should be able to map to text column -->
                                            <!--  colType: {{col.colType.toUpperCase()}} nenaType: {{field.NenaType.toUpperCase()}}  -->
                                    </select>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <app-feature-float-preview #previewFloat [previewRows]="previewRows" [previewColumns]="previewColumns" [hidden]="!isPreview" (close)="closePreview()"></app-feature-float-preview> -->

<ng-template #cellTempl let-row="row" let-column="column" let-value="value">
    <div [ngClass]="{'grey-cell': row[column.prop] === null}">{{row[column.prop] === null ? "null": value }}</div>
</ng-template>
